import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveEmailTemplate = async (uuid: string) => {
  const response = await CustomAxios.post(`email_templates/${uuid}/archive`);
  return response.data;
};
interface UseArchiveEmailTemplateProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveEmailTemplate({ uuid, onSuccessCallback }: UseArchiveEmailTemplateProps) {
  return useMutation({
    mutationFn: () => archiveEmailTemplate(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmailTemplates, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the email template. Please try again and contact support if the problem persists.');
      } else {
        console.error('Unexpected error archiving email template:', err);
      }
    },
  });
}
